module.exports = __webpack_public_path__ + "static/media/el-pais-de-lilac-min.1d4a2677.png";